// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--7-1!../../node_modules/postcss-loader/lib/index.js??ref--7-2!../../node_modules/px2rem-loader/index.js??ref--7-3!./iconfont.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("28b25278", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./static/iconfont/iconfont.css
// module id = NWtE
// module chunks = 272